import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "11.293",
  height: "13.817",
  viewBox: "0 0 11.293 13.817"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.047,15.617s5.047-2.523,5.047-6.308V4.892L11.047,3,6,4.892V9.308C6,13.093,11.047,15.617,11.047,15.617Z",
      transform: "translate(-5.4 -2.4)",
      fill: "none",
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2"
    }, null, -1)
  ])))
}
export default { render: render }